var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.stocks),function(stock){return _c('app-stock',{key:stock.id,attrs:{"stock":stock}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }